'use client'

/**
 * Heartbeat aktywności — pinguje /api/crm/activity/ping przy REALNEJ interakcji
 * (klik/klawisz/scroll/ruch myszy), max raz na 60 s. Brak interakcji = brak pingów
 * → admin widzi „bezczynny X min". Nie pinguje bez tokenu (np. na logowaniu).
 */
import { useEffect, useRef } from 'react'
import { getToken } from '@/lib/api-client'

export default function ActivityHeartbeat() {
  const last = useRef(0)
  useEffect(() => {
    const ping = () => {
      const now = Date.now()
      if (now - last.current < 60000) return
      const token = getToken()
      if (!token) return
      last.current = now
      fetch('/api/crm/activity/ping', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ platform: 'web' }),
      }).catch(() => {})
    }
    ping()
    const events = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart']
    events.forEach((e) => window.addEventListener(e, ping, { passive: true }))

    // Monitoring anty-wyciek: loguj duże kopiowania i PrintScreen (nie blokuje, alarmuje przy nadmiarze).
    const pageCtx = () => (typeof window !== 'undefined' ? (window.location.pathname + window.location.search).slice(0, 300) : '')
    const logEvent = (type: string, meta?: number, content?: string, context?: string) => {
      const token = getToken(); if (!token) return
      fetch('/api/crm/activity/event', {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, meta, platform: 'web', content, context }),
      }).catch(() => {})
    }
    const onCopy = () => { const sel = window.getSelection()?.toString() || ''; if (sel.length >= 40) logEvent('copy', sel.length, sel.slice(0, 1000), pageCtx()) }
    const onKey = (e: KeyboardEvent) => { if (e.key === 'PrintScreen') logEvent('printscreen', undefined, undefined, pageCtx()) }
    document.addEventListener('copy', onCopy)
    window.addEventListener('keyup', onKey)

    return () => {
      events.forEach((e) => window.removeEventListener(e, ping))
      document.removeEventListener('copy', onCopy)
      window.removeEventListener('keyup', onKey)
    }
  }, [])
  return null
}
